import markList from '@/views/reports/pickers/add-marks/mark-list';
import type { ReportCellMark } from '@/views/report/report-cell-display';

export const resolveRowMark = (data: Record<string, unknown>): ReportCellMark | undefined => {
  if (!data.DT_RowMark && data.DT_RowMark !== 0) return;

  const markData = markList.find((item) => +item.mark === +data.DT_RowMark);
  if (!markData) return;

  return {
    icon: markData.icon,
    colorKey: markData.color,
    className: markData.class,
  };
};

export const isArchivedNameCell = (
  data: Record<string, unknown>,
  key: string,
): boolean => data.DT_RowStatus === 'archived' && data.DT_RowName === data[key];
